module.exports = __webpack_public_path__ + "img/9788957980941.23f6f495.jpg";